import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import Flex from '@Components/Bases/Flex';
import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { CorporateInformationFormValues } from '../NatureOfBusinessFormProvider/types';
import FormCompletionCheckBox from './FormCompletionCheckBox';
import GeneralInformationForm from './GeneralInformationForm';

const GeneralInformation = () => {
  const { getValues } = useNatureOfBusinessForm();
  const { introduction, remark } =
    getValues(`corporateInformation`) ?? ({} as CorporateInformationFormValues);
  const [disclosureOpen, { open: openDisclosure, close: closeDisclosure }] =
    useDisclosure();
  const [
    introductionOpen,
    { open: openIntroduction, close: closeIntroduction },
  ] = useDisclosure(!!introduction);
  const [remarkOpen, { open: openRemark, close: closeRemark }] = useDisclosure(
    !!remark
  );
  const { completedSection } =
    useWatch({
      name: 'corporateInformation',
    }) ?? ({} as CorporateInformationFormValues);
  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <Box borderRadius={1} bgcolor={'white'}>
      <Flex justifyContent={'space-between'} alignItems={'center'} p={2}>
        <Flex gap={1} alignItems={'center'}>
          <Typography fontWeight={'bold'}>ข้อมูลบริษัท</Typography>
          <IntroductionButton
            onClick={openIntroduction}
            disabled={isCompletedTh && isCompletedEn}
          />
          <RemarkButton
            onClick={openRemark}
            disabled={isCompletedTh && isCompletedEn}
          />
        </Flex>
        <Button
          color={'inherit'}
          startIcon={<InfoPopUpIcon />}
          onClick={openDisclosure}
        >
          แนวทางการเปิดเผย
        </Button>
        <DisclosureGuidelineModal
          open={disclosureOpen}
          onClose={closeDisclosure}
          title="ข้อมูลทั่วไปของบริษัท"
          note={
            <ul
              style={{ paddingLeft: '16px', listStyleType: 'disc', margin: 0 }}
            >
              <li style={{ marginBottom: '4px' }}>
                ตัวอักษรปกติ แสดงถึง ข้อกำหนดของแบบ Corporate Value Up
                ตามประกาศคณะกรรมการกำกับตลาดทุนว่าด้วยหลักเกณฑ์ เงื่อนไข
                และวิธีการรายงานการเปิดเผย
                ข้อมูลเกี่ยวกับฐานะการเงินและผลการดำเนินงานของบริษัทที่ออกหลักทรัพย์
              </li>
              <li>
                ตัวอักษรเอียง แสดงถึง คำอธิบาย แนวปฏิบัติ คำแนะนำ
                และตัวอย่างประกอบเพิ่มเติม
                ซึ่งจะมีคำอธิบายเฉพาะหัวข้อที่อาจมีปัญหาในทางปฏิบัติ
                หรืออาจต้องการแนวปฏิบัติหรือคำแนะนำที่ช่วยในการจัดทำแบบ
                Corporate Value Up
              </li>
            </ul>
          }
          description={
            <>
              <Typography mt={2}>
                ชื่อ สถานที่ตั้งสำนักงานใหญ่ ประเภทธุรกิจ เลขทะเบียนบริษัท
                โทรศัพท์ โทรสาร เว็บไซต์บริษัท (ถ้ามี)
              </Typography>
              <Typography>
                จำนวนและชนิดของหุ้นที่จำหน่ายได้แล้วทั้งหมดของบริษัท
              </Typography>
            </>
          }
        />
      </Flex>
      {introductionOpen && (
        <Flex p={2} flexDirection={'column'} bgcolor={'white'} gap={2}>
          <Introduction
            topic="ข้อมูลทั่วไปของบริษัท"
            setOpen={closeIntroduction}
            fieldPath="corporateInformation.introduction"
            onDelete={closeIntroduction}
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
        </Flex>
      )}
      <GeneralInformationForm />
      {remarkOpen && (
        <Flex p={2} flexDirection={'column'} bgcolor={'white'} gap={2}>
          <Remark
            topic="ข้อมูลทั่วไปของบริษัท"
            setOpen={closeRemark}
            fieldPath="corporateInformation.remark"
            onDelete={closeRemark}
            isCompletedTh={isCompletedTh}
            isCompletedEn={isCompletedEn}
          />
        </Flex>
      )}
      <FormCompletionCheckBox />
    </Box>
  );
};

export default GeneralInformation;
